export default __webpack_public_path__ + "static/media/0.aae354cf.jpg";